import appConfig from "@/config/appConfig";
import { Spin } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { FiEye } from "react-icons/fi";
import { Link } from "react-router-dom";
import { DataTable } from "@/components";

const MySubscriptionSummary = () => {
  const [subscriptionSummary, setSubscriptionSummary] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const getSubscriptionSummary = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`/subscription/assign-plan/`, {
        withCredentials: true,
      });
      let arr = response.data?.result.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));
      arr = arr.map((item, idx) => {
        item.sl = idx + 1;
        return item;
      });
      setSubscriptionSummary(arr);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    document.title = appConfig.name + " - My Subscription Summary";
    getSubscriptionSummary();
  }, []);

  const columns = [
    {
      title: "No.",
      render: (row) => row.sl,
      width: "60px",
      align: "center",
    },
    {
      title: "Plan Name",
      render: (_, row) => row?.name || "--",
      align: "center",
    },
    {
      title: "Duration",
      render: (_, row) => row?.duration || "--",
      align: "center",
    },
    {
      title: "Start Date",
      render: (_, row) => moment(row.startDate).format("DD/MM/YYYY"),
      align: "center",
    },
    {
      title: "End Date",
      render: (_, row) => moment(row.endDate).format("DD/MM/YYYY"),
      align: "center",
    },
    {
      title: "SMS",
      render: (_, row) => (
        <div>
          {row?.smsNotificationType || "--"}
          {row?.smsNotificationType === "Yes" ? `(${row?.smsCount || 0})` : ""}
        </div>
      ),
      align: "center",
    },
    {
      title: "Date Assigned",
      render: (_, row) => moment(row.createdAt).format("DD/MM/YYYY"),
      align: "center",
    },
    {
      title: "Status",
      render: (_, row) => (
        <div>
          {row.isActive ? (
            <span className="badge text-bg-success">Active</span>
          ) : (
            <span className="badge text-bg-danger">Deactivated</span>
          )}
        </div>
      ),
      align: "center",
    },
    {
      title: "Action",
      align: "center",
      render: (_, row) => (
        <div className="actions">
          <Link to={`/subscription/details/${row._id}`} className="btn btn-success">
            <FiEye title="View Assinged Plan" />
          </Link>
        </div>
      ),
    },
  ];

  return (
    <div className="az-content-body p-0 px-md-3">
      <div className="row row-sm mg-b-15 mg-sm-b-20">
        <div className="col-lg-12">
          <div className="card card-dashboard-six">
            <div className="card-header mb-3">
              <div>
                <label className="az-content-label">Manage Subscriptions</label>
                <span className="d-block py-2">My Subscription Summary</span>
              </div>
            </div>

            <Spin spinning={isLoading}>
              <DataTable
                dataSource={subscriptionSummary}
                columns={columns}
                rowKey={(record) => record.id}
                pagination={{
                  defaultPageSize: 10,
                  showSizeChanger: true,
                  showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
                  pageSizeOptions: [10, 20, 50],
                  responsive: true,
                }}
              />
            </Spin>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MySubscriptionSummary;
